import React, { Fragment } from "react";

import { validate, styles } from "./util";

import { Stack, Typography, Checkbox, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { Field } from "formik";

const RoundedUncheckedIcon = (
  <Box
    sx={{
      width: 20,
      height: 20,
      border: "1px solid #ACBEE8",
      borderRadius: "5px",
      boxSizing: "border-box",
    }}
  />
);
const RoundedCheckedIcon = (
	<Box
		sx={{
			width: 20,
			height: 20,
			borderRadius: "5px",
			backgroundColor: "#6C63FF",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		}}
	>
		<svg
			width="14"
			height="14"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 12l5 5L20 7"
				stroke="white"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Box>
);
export default function CheckboxField(props) {
  let {
    formik,
    type,
    name,
    options,
    displayKey,
    valueKey,
    noneKey,
    planType,
    showInclude = true,
    showExclude = true,
    showHeading = true,
    shouldShowErrors,
  } = props;
  let { disabled, hidden, validation, onSelect } = props;

  const { values, setFieldValue, errors, touched } = formik;
  const selectedValues = values?.[name];
  const showError = shouldShowErrors !== undefined ? shouldShowErrors : false;
  const error =
    showError && touched?.[name] && errors?.[name] ? errors?.[name] : "";

  if (typeof options === "function")
    options = options({ ...formik, name, value: selectedValues });
  if (typeof disabled === "function")
    disabled = disabled({ ...formik, name, value: selectedValues });
  if (typeof hidden === "function")
    hidden = hidden({ ...formik, name, value: selectedValues });

  async function handleChange(event, checked = null) {
    try {
      const key = event?.target?.id || event?.target?.value;
      const prevValue = selectedValues?.[key];

      checked = checked === null ? event?.target?.checked : checked;
      checked = checked === prevValue ? null : checked;
      let value = { [key]: checked };

      if (type === "checkbox" || type === "checkbox-pair") {
        value = { ...selectedValues, [key]: checked };

        if (noneKey)
          value = { ...selectedValues, [key]: checked, [noneKey]: false };
        if (checked && noneKey && key === noneKey) value = { [noneKey]: true };
      }

      setFieldValue(name, value);

      if (onSelect) {
        formik.values[name] = value;
        await onSelect({ ...formik, name, value });
      }
    } catch (error) {
      console.error(error);
    }
  }

  function handleValidation(value, pair = false) {
    if (typeof validation === "string") {
      if (validate.selected(value, pair)) {
        return validate.selected(value, pair);
      }
    }

    if (typeof validation === "function") {
      return validation({ ...formik, name, value });
    }
  }

  const showPairColumns = planType === "QSEHRA" || planType === "ICHRA";

  const checkboxSx = { padding: 0 };

  return hidden ? (
    <Fragment />
  ) : (
    <Stack spacing="15px">
      {type === "checkbox-pair" && showHeading && (
        <Stack
          direction="row"
          spacing="10px"
          sx={
            showInclude && showExclude && showPairColumns
              ? styles.checkboxPairContainerFull
              : styles.checkboxPairContainer
          }
        >
          {showInclude && <Typography>Include</Typography>}
          {showExclude && showPairColumns && (
            <Fragment>
              {showInclude && showExclude && <Typography>|</Typography>}
              <Typography>Exclude</Typography>
            </Fragment>
          )}
        </Stack>
      )}

      {options?.map((option) => {
        const display = displayKey ? option?.[displayKey] : option;
        const value = valueKey ? option?.[valueKey] : option;
        const content = option?.content;
        const optionDisabled = option?.disabled;
        let checked = Boolean(selectedValues?.[value]);
        if (type === "checkbox-pair") checked = selectedValues?.[value];

        return (
          <Stack key={value} direction="column" spacing="10px">
            <Stack key={value} direction="row" spacing="10px">
              {type === "checkbox-pair" ? (
                <Stack
                  direction="row"
                  spacing="50px"
                  sx={
                    showInclude && showExclude && showPairColumns
                      ? styles.checkboxPairContainerFull
                      : styles.checkboxPairContainer
                  }
                >
                  <Field
                    name={name}
                    validate={(v) => handleValidation(v, true)}
                  >
                    {() => (
                      <Fragment>
                        {showInclude ? (
                          <Checkbox
                            id={value}
                            checked={checked === true}
                            disabled={optionDisabled || disabled}
                            onChange={(event) => handleChange(event, true)}
                            icon={RoundedUncheckedIcon}
                            checkedIcon={RoundedCheckedIcon}
                            sx={checkboxSx}
                          />
                        ) : (
                          <Stack sx={{ width: "25px" }}></Stack>
                        )}
                        {showExclude && showPairColumns ? (
                          <Checkbox
                            id={value}
                            checked={checked === false}
                            disabled={optionDisabled || disabled}
                            onChange={(event) => handleChange(event, false)}
                            icon={RoundedUncheckedIcon}
                            checkedIcon={RoundedCheckedIcon}
                            sx={checkboxSx}
                          />
                        ) : (
                          <Stack sx={{ width: "25px" }}></Stack>
                        )}
                      </Fragment>
                    )}
                  </Field>
                </Stack>
              ) : (
                <Field name={name} validate={handleValidation}>
                  {() => (
                    <Checkbox
                      id={value}
                      checked={checked}
                      disabled={optionDisabled || disabled}
                      onChange={handleChange}
                      icon={RoundedUncheckedIcon}
                      checkedIcon={RoundedCheckedIcon}
                      sx={checkboxSx}
                    />
                  )}
                </Field>
              )}

              <Typography
                component="label"
                htmlFor={value}
                sx={styles.checkboxLabel}
              >
                {display}
              </Typography>
            </Stack>

            {content && <Fragment>{React.createElement(content)}</Fragment>}
          </Stack>
        );
      })}
      {error ? <Typography sx={styles.error}>{error}</Typography> : null}
    </Stack>
  );
}
